export default {
  aspectRatio: {},
  splitter: {
    display: 'flex',
    alignItems: 'center'
  }
};
